import { Navigate } from 'react-router-dom';

const Root = () => {
    return <Navigate to="/account/vendor-login" replace />;
};

export default Root;